import { socialPostEditableDraftSchema, type SocialPostEditableDraft } from "@runcheetah/shared";

export type SocialPostEditorCarouselTarget = {
  slideId: string;
  slideIndex: number;
};

export const mergeActiveSocialPostEditDraft = (input: {
  baseDraft: SocialPostEditableDraft;
  activeDraft: SocialPostEditableDraft;
  carouselTarget?: SocialPostEditorCarouselTarget | null;
}): SocialPostEditableDraft => {
  if (!input.carouselTarget) {
    return socialPostEditableDraftSchema.parse(input.activeDraft);
  }

  const { slideId, slideIndex } = input.carouselTarget;
  const nextCarouselSlides = input.baseDraft.carouselSlides.map((slideDraft) =>
    slideDraft.slideId === slideId ? { ...slideDraft, plan: input.activeDraft.plan } : slideDraft,
  );
  const hasActiveSlideDraft = nextCarouselSlides.some(
    (slideDraft) => slideDraft.slideId === slideId,
  );

  if (!hasActiveSlideDraft) {
    nextCarouselSlides.push({
      slideId,
      slideIndex,
      plan: input.activeDraft.plan,
      imageAssetOverrides: input.activeDraft.imageAssetOverrides,
    });
  }

  return socialPostEditableDraftSchema.parse({
    ...input.baseDraft,
    caption: input.activeDraft.caption,
    hashtags: input.activeDraft.hashtags,
    plan:
      slideIndex === 1 || input.baseDraft.carouselSlides.length === 0
        ? input.activeDraft.plan
        : (nextCarouselSlides.find((slideDraft) => slideDraft.slideIndex === 1)?.plan ??
          input.baseDraft.plan),
    carouselSlides: nextCarouselSlides.toSorted(
      (left, right) => left.slideIndex - right.slideIndex,
    ),
  });
};
